(function (window, document) {
  'use strict';

  var VERSION = '2.1.0';
  var RESULT_MAP = {
    einstieg: ['Ihr Einstieg in Pflege und Betreuung', 'Ein schrittweiser Lernweg verbindet Grundlagen, Praxistransfer und einen nachvollziehbaren Kompetenzaufbau.', '/collections/pflegehilfe-programm'],
    angehoerige: ['Sicher begleiten und im Alltag anwenden', 'Verständliche Grundlagen und konkrete Alltagssituationen werden zu einem tragfähigen Lernweg verbunden.', '/collections/angehorigenpflege'],
    vertiefung: ['Fachwissen gezielt vertiefen', 'Ihre Erfahrung wird mit einem passenden Fachthema, Lernformat und nächsten Kompetenzschritt verbunden.', '/collections/kurse-fachthemen'],
    team: ['Kompetenzen im Team entwickeln', 'Ein Firmenkurs beginnt mit Bedarf, Lernziel und Transfer und wird danach verbindlich geplant.', '/collections/firmenkurse']
  };
  var LANGUAGE_SUPPORT = {
    fachsprache: 'Sie fühlen sich in der gewählten Kurssprache auch bei Fachtexten sicher. Prüfen Sie dennoch die konkreten Voraussetzungen des Angebots.',
    alltagssprache: 'Klare Erklärungen der Fachbegriffe unterstützen Ihren Lernweg. Fragen Sie beim Angebot nach Unterlagen und sprachlicher Begleitung.',
    'klare-sprache': 'Ein Angebot mit klarer, einfacher Sprache und gut strukturierten Unterlagen kann passend sein. Wir klären dies gerne vor der Buchung.',
    klaeren: 'Die sprachlichen Voraussetzungen werden vor der Buchung persönlich und ohne Bewertung geklärt.'
  };
  var ANSWER_NAMES = [
    ['goal', 'Ziel'],
    ['experience', 'Erfahrung'],
    ['education', 'Bildungsstand'],
    ['topic', 'Thema'],
    ['language', 'Kurssprache'],
    ['language_level', 'Umgang mit der Kurssprache'],
    ['format', 'Lernformat'],
    ['region', 'Region'],
    ['funding', 'Vor der Entscheidung klären']
  ];
  var RANKING_TOKENS = {
    experience: {
      neu: ['grundkurs', 'einstieg', 'basis'],
      praxis: ['praxis', 'plus', 'aufbau'],
      fachperson: ['fach', 'vertiefung', 'professional']
    },
    education: {
      'ohne-abschluss': ['grundkurs', 'einstieg', 'basis'],
      kurs: ['kurs', 'modul', 'aufbau'],
      abschluss: ['fach', 'vertiefung', 'professional']
    },
    topic: {
      pflege: ['pflege', 'betreuung', 'angehör'],
      psyche: ['psychi', 'psych', 'mental'],
      kommunikation: ['kommunikation', 'deeskalation', 'aggression'],
      organisation: ['führung', 'organisation', 'team', 'management'],
      offen: []
    },
    format: {
      'Präsenz kompakt': ['präsenz', 'vor ort', 'kompakt'],
      'Online flexibel': ['online', 'digital', 'e-learning'],
      'Blended Learning': ['blended', 'hybrid'],
      Module: ['modul', 'programm', 'lehrgang']
    },
    language: {
      Deutsch: ['deutsch'],
      Französisch: ['französisch', 'français'],
      Italienisch: ['italienisch', 'italiano'],
      Englisch: ['englisch', 'english']
    },
    region: {
      Zürich: ['zürich'],
      Schwyz: ['schwyz', 'wollerau'],
      Online: ['online', 'digital'],
      Inhouse: ['inhouse', 'firmenkurs'],
      Flexibel: []
    }
  };

  function getResult(goal) {
    return RESULT_MAP[goal] || RESULT_MAP.vertiefung;
  }

  function scoreCourse(course, answers, originalIndex) {
    var text = String(course.search || '').toLocaleLowerCase('de-CH');
    var available = course.available === true || course.available === 'true';
    var score = available ? 2 : -2;
    Object.keys(RANKING_TOKENS).forEach(function (field) {
      var tokenMap = RANKING_TOKENS[field];
      var tokens = tokenMap[answers[field]] || [];
      if (tokens.some(function (token) { return text.indexOf(token) !== -1; })) score += 2;
    });
    return { score: score, available: available, originalIndex: originalIndex };
  }

  function rankCourseData(courses, answers, limit) {
    return courses.map(function (course, originalIndex) {
      var scored = scoreCourse(course, answers, originalIndex);
      return { course: course, score: scored.score, available: scored.available, originalIndex: originalIndex };
    }).filter(function (item) {
      return item.available && item.score >= 4;
    }).sort(function (left, right) {
      return right.score - left.score || left.originalIndex - right.originalIndex;
    }).slice(0, limit || 3);
  }

  var engine = {
    version: VERSION,
    getResult: getResult,
    rankCourseData: rankCourseData,
    resultGoals: Object.keys(RESULT_MAP)
  };
  window.BildungsdienstCompassEngine = engine;

  function elements(root) {
    var form = root.querySelector('[data-compass-form]');
    return {
      form: form,
      steps: form ? Array.prototype.slice.call(form.querySelectorAll('[data-compass-step]')) : [],
      next: form && form.querySelector('[data-compass-next]'),
      back: form && form.querySelector('[data-compass-back]'),
      progress: form && form.querySelector('[data-compass-progress]'),
      bar: form && form.querySelector('[data-compass-bar]'),
      validation: form && form.querySelector('[data-compass-validation]'),
      map: root.querySelector('.compass-map'),
      result: root.querySelector('[data-compass-result]')
    };
  }

  function fail(root, message, error) {
    root.removeAttribute('data-compass-ready');
    root.setAttribute('data-compass-error', 'true');
    var validation = root.querySelector('[data-compass-validation]');
    if (validation) {
      validation.hidden = false;
      validation.textContent = message || 'Der Kompass konnte nicht gestartet werden. Bitte laden Sie die Seite neu oder kontaktieren Sie uns.';
    }
    if (window.console && console.error) console.error('Bildungs-Kompass:', error || message);
  }

  function currentIndex(root, total) {
    var index = Number(root.dataset.compassIndex || 0);
    return Number.isFinite(index) ? Math.max(0, Math.min(total - 1, index)) : 0;
  }

  function update(root, focusQuestion) {
    var el = elements(root);
    if (!el.form || !el.steps.length || !el.next || !el.back || !el.progress || !el.bar || !el.validation) {
      throw new Error('Erforderliche Kompass-Elemente fehlen.');
    }
    var index = currentIndex(root, el.steps.length);
      el.steps.forEach(function (step, stepIndex) {
        var isCurrent = stepIndex === index;
        step.hidden = !isCurrent;
        step.setAttribute('aria-hidden', String(!isCurrent));
      });
    el.back.hidden = index === 0;
    el.next.textContent = index === el.steps.length - 1 ? 'Persönliche Lernspur anzeigen' : 'Weiter';
    el.progress.textContent = String(index + 1) + ' / ' + String(el.steps.length);
    el.bar.style.width = String(((index + 1) / el.steps.length) * 100) + '%';
    el.validation.hidden = true;
    var nodes = Array.prototype.slice.call(root.querySelectorAll('[data-map-node]'));
    var active = Math.floor(index / Math.max(1, el.steps.length - 1) * Math.max(0, nodes.length - 1));
    nodes.forEach(function (node, nodeIndex) { node.classList.toggle('is-active', nodeIndex <= active); });
    if (focusQuestion) {
      var target = el.steps[index].querySelector('input:checked, input');
      if (target) target.focus();
    }
  }

  function init(root) {
    if (!root || root.dataset.compassReady === VERSION) return true;
    try {
      var el = elements(root);
      if (!el.form || el.steps.length !== 9 || !el.next || !el.result) throw new Error('Kompass-Struktur ist unvollständig.');
      root.dataset.compassIndex = root.dataset.compassIndex || '0';
      update(root, false);
      root.dataset.compassReady = VERSION;
      root.removeAttribute('data-compass-error');
      return true;
    } catch (error) {
      fail(root, null, error);
      return false;
    }
  }

  function selectedLabel(form, name) {
    var selected = form.querySelector('input[name="' + name + '"]:checked');
    var label = selected && selected.closest('label');
    return label ? label.textContent.trim() : 'Nicht angegeben';
  }

  function answerObject(form) {
    var answers = {};
    ANSWER_NAMES.forEach(function (entry) {
      var selected = form.querySelector('input[name="' + entry[0] + '"]:checked');
      answers[entry[0]] = selected ? selected.value : '';
    });
    return answers;
  }

  function renderAnswerSummary(root, form) {
    var summary = root.querySelector('[data-result-answers]');
    if (!summary) throw new Error('Antwortübersicht fehlt.');
    summary.replaceChildren();
    ANSWER_NAMES.forEach(function (entry) {
      var term = document.createElement('dt');
      var value = document.createElement('dd');
      term.textContent = entry[1];
      value.textContent = selectedLabel(form, entry[0]);
      summary.append(term, value);
    });
  }

  function rankCatalogCourses(root, goal, answers) {
    root.querySelectorAll('[data-compass-courses]').forEach(function (group) {
      var selectedGroup = group.dataset.compassCourses === goal;
      group.hidden = !selectedGroup;
      var cards = Array.prototype.slice.call(group.querySelectorAll('[data-compass-course]'));
      cards.forEach(function (card) { card.hidden = true; });
      if (!selectedGroup) return;
      var ranked = rankCourseData(cards.map(function (card) {
        return { element: card, available: card.dataset.courseAvailable, search: card.dataset.courseSearch || '' };
      }), answers, 3);
      ranked.forEach(function (item) {
        item.course.element.hidden = false;
        var link = item.course.element.querySelector('a[href]');
        if (link && answers.region) {
          var target = new URL(link.href, window.location.origin);
          target.searchParams.set('praeferenz_ort', answers.region);
          target.searchParams.set('quelle', 'bildungs-kompass');
          link.href = target.pathname + target.search;
        }
      });
      var noMatch = group.querySelector('[data-compass-no-match]');
      if (noMatch) noMatch.hidden = ranked.length > 0;
    });
  }

  function updateDeepLinks(root, answers) {
    var allowed = {
      goal: ['einstieg','angehoerige','vertiefung','team'],
      experience: ['neu','praxis','fachperson'],
      education: ['ohne-abschluss','kurs','abschluss'],
      topic: ['pflege','psyche','kommunikation','organisation','offen'],
      language: ['Deutsch','Französisch','Italienisch','Englisch'],
      language_level: ['fachsprache','alltagssprache','klare-sprache','klaeren'],
      format: ['Präsenz kompakt','Online flexibel','Blended Learning','Module'],
      region: ['Zürich','Schwyz','Online','Inhouse','Flexibel'],
      funding: ['Finanzierung prüfen','Voraussetzungen prüfen','Angebote vergleichen','Persönlich beraten']
    };
    var target = new URL('https://www.bildungsdienst.ch/');
    target.searchParams.set('source','shop_compass');
    Object.keys(allowed).forEach(function (key) {
      if (allowed[key].indexOf(answers[key]) !== -1) target.searchParams.set(key,answers[key]);
    });
    target.hash = 'kompass';
    root.querySelectorAll('[data-compass-deep-link]').forEach(function (link) {
      link.href = target.href;
    });
  }

  function renderResult(root) {
    var el = elements(root);
    var answers = answerObject(el.form);
    var selected = getResult(answers.goal);
    var title = root.querySelector('[data-result-title]');
    var text = root.querySelector('[data-result-text]');
    var date = root.querySelector('[data-result-date]');
    var orientation = root.querySelector('[data-result-orientation]');
    var reason = root.querySelector('[data-result-reason]');
    var language = root.querySelector('[data-result-language]');
    var list = root.querySelector('[data-result-steps]');
    var shopLink = root.querySelector('[data-result-shop]');
    if (!title || !text || !date || !orientation || !reason || !language || !list || !shopLink || !el.result) {
      throw new Error('Ergebnisbereich ist unvollständig.');
    }
    title.textContent = selected[0];
    text.textContent = selected[1];
    date.textContent = 'Erstellt am ' + new Intl.DateTimeFormat('de-CH').format(new Date());
    orientation.textContent = [selectedLabel(el.form, 'topic'), selectedLabel(el.form, 'format'), selectedLabel(el.form, 'region'), selectedLabel(el.form, 'language')].join(' · ');
    reason.textContent = 'Ihr Ziel bestimmt die passende Kataloggruppe. Erfahrung, Bildungsstand, Thema, Kurssprache, Lernformat und Region ordnen die Angebote nach den veröffentlichten Katalogangaben. Sprachniveau und Klärungsbedarf werden transparent im Bericht ausgewiesen und beim konkreten Kurs geprüft.';
    language.textContent = LANGUAGE_SUPPORT[answers.language_level] || LANGUAGE_SUPPORT.klaeren;
    updateDeepLinks(root, answers);
    renderAnswerSummary(root, el.form);
    list.replaceChildren();
    [
      'Die vorgeschlagenen Angebote und deren Voraussetzungen vergleichen.',
      'Termin, Preis, Durchführungsform und Verfügbarkeit im Shop prüfen.',
      (answers.funding || 'Offene Punkte klären') + ' und bei offenen Fragen Kontakt aufnehmen.'
    ].forEach(function (stepText) {
      var item = document.createElement('li');
      item.textContent = stepText;
      list.appendChild(item);
    });
    shopLink.href = selected[2];
    rankCatalogCourses(root, answers.goal, answers);
    el.form.hidden = true;
    el.form.setAttribute('aria-hidden', 'true');
    if (el.map) {
      el.map.hidden = true;
      el.map.setAttribute('aria-hidden', 'true');
    }
    el.result.hidden = false;
    el.result.setAttribute('aria-hidden', 'false');
    el.result.focus();
  }

  function next(root) {
    if (!init(root)) return;
    try {
      var el = elements(root);
      var index = currentIndex(root, el.steps.length);
      var field = el.steps[index];
      var chosen = field.querySelector('input:checked');
      if (!chosen) {
        el.validation.hidden = false;
        el.validation.textContent = 'Bitte wählen Sie zuerst eine Antwort aus.';
        var firstInput = field.querySelector('input');
        if (firstInput) firstInput.focus();
        return;
      }
      if (index < el.steps.length - 1) {
        root.dataset.compassIndex = String(index + 1);
        update(root, true);
        return;
      }
      renderResult(root);
    } catch (error) {
      fail(root, 'Die Auswertung konnte nicht erstellt werden. Bitte laden Sie die Seite neu oder kontaktieren Sie uns.', error);
    }
  }

  function back(root) {
    if (!init(root)) return;
    try {
      var el = elements(root);
      var index = currentIndex(root, el.steps.length);
      if (index > 0) root.dataset.compassIndex = String(index - 1);
      update(root, true);
    } catch (error) {
      fail(root, null, error);
    }
  }

  function reset(root) {
    if (!init(root)) return;
    try {
      var el = elements(root);
      el.form.reset();
      root.dataset.compassIndex = '0';
      el.form.hidden = false;
      el.form.setAttribute('aria-hidden', 'false');
      if (el.map) {
        el.map.hidden = false;
        el.map.setAttribute('aria-hidden', 'false');
      }
      el.result.hidden = true;
      el.result.setAttribute('aria-hidden', 'true');
      root.querySelectorAll('[data-compass-course], [data-compass-no-match]').forEach(function (item) {
        item.hidden = true;
        item.setAttribute('aria-hidden', 'true');
      });
      update(root, true);
    } catch (error) {
      fail(root, null, error);
    }
  }

  function initAll(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    base.querySelectorAll('[data-shopify-compass]').forEach(init);
    if (base.matches && base.matches('[data-shopify-compass]')) init(base);
  }

  if (!document.documentElement.dataset.compassDelegated) {
    document.documentElement.dataset.compassDelegated = VERSION;
    document.addEventListener('click', function (event) {
      var target = event.target.closest && event.target.closest('[data-compass-next], [data-compass-back], [data-reset-compass], [data-print-compass]');
      if (!target) return;
      var root = target.closest('[data-shopify-compass]');
      if (!root) return;
      if (target.matches('[data-compass-next]')) next(root);
      else if (target.matches('[data-compass-back]')) back(root);
      else if (target.matches('[data-reset-compass]')) reset(root);
      else window.print();
    }, true);
    document.addEventListener('change', function (event) {
      var root = event.target.closest && event.target.closest('[data-shopify-compass]');
      if (!root || !event.target.matches('input[type="radio"]')) return;
      var validation = root.querySelector('[data-compass-validation]');
      if (validation) validation.hidden = true;
    });
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  }

  window.BildungsdienstCompass = { version: VERSION, init: init, initAll: initAll };
  initAll(document);
})(window, document);
